import { get } from "lodash";

export const getPaymentIsLoading = state => get(state, "payment.loading");
export const getPaymentDetails = state => get(state, "payment", {});
export const getBookingReference = state =>
get(state, "payment.bookingReference", "");
export const getPaymentClientSecret = state => get(state, "clientSecret");
